<template>
  <sweet-modal :title="$t('general_document')" blocking ref="documentModal" class="modal" v-on:close="close">
    <el-card class="box-card" style="margin:10px 0;">
      <div class="text item">
        <span class="box-card_title">{{$t('modal_documentManagment_status_documentType')}}</span>
        <span style="text-transform: uppercase;"> {{params.type}}</span>
      </div>
      <el-divider></el-divider>
      <div class="text item">
        <span class="box-card_title">{{$t('modal_documentManagment_status_documentTitle')}}</span>
        <span> {{params.documentTitle}}</span>
      </div>
      <el-divider></el-divider>
      <div class="text item">
        <span class="box-card_title">{{$t('modal_documentManagment_status_documentNo')}}</span> {{params.documentNo}}
      </div>
      <el-divider></el-divider>
      <div class="text item">
        <span class="box-card_title">{{$t('modal_documentManagment_status_revisionNo')}}</span> {{params.revisionNo}}
      </div>
      <el-divider></el-divider>
      <div class="text item">
        <div v-if="params.projectTaskName">
          <span class="box-card_title" >{{$t('modal_documentManagment_status_project')}}</span>
          <span> {{params.projectName}}</span>
        </div>
        <div v-if="params.businessUnitTaskName">
          <span class="box-card_title">{{$t('modal_documentManagment_status_businessUnit')}}</span>
          <span> {{params.businessUnitName}}</span>
        </div>
        <div v-if="params.engagementtaskName">
          <span class="box-card_title">{{$t('modal_documentManagment_status_engagement')}}</span>
          <span> {{params.engagementName}}</span>
        </div>
      </div>
      <el-divider></el-divider>
      <div class="text item">
        <span class="box-card_title">{{$t('modal_documentManagment_status_task')}}</span> {{params.businessUnitTaskName || params.projectTaskName || params.engagementTaskName}}
      </div>
      <el-divider></el-divider>
      <div v-if="params.rejectMessage" class="text item" style="background: #ffcfcf;">
        <span class="box-card_title">{{$t('modal_documentManagment_status_rejectMessage')}}</span> {{params.rejectMessage}}
      </div>
    </el-card>
    <div v-html="params.documentContent">
    </div>
    <h4 v-if="params.documentFiles.length">{{$t('modal_documentManagment_attachments')}}</h4>
    <el-dropdown placement="bottom" v-for="item in params.documentFiles" :key="item.id" class="item__file">
                  <span class="el-dropdown-link" style="cursor:pointer;">
                    <i class="el-icon-link"></i>
                    <span>{{item.name}}</span>
                  </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item @click.native="viewFile(item.url + `/${item.name}`)" icon="el-icon-view">{{$t('project_tab_files_first_view')}}</el-dropdown-item>
        <el-dropdown-item class="download-btn" icon="el-icon-upload"><a :href="`${item.url}/${item.name}?mode=attachment`">{{$t('project_tab_files_first_download')}}</a></el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <div v-if="viewerType == 1">
      <sweet-modal blocking v-if="viewerType == 1" ref="nestedChild">
        <iframe class="iframe" :src="fileUrl" frameborder="0"></iframe>
      </sweet-modal>
    </div>
    <div v-if="viewerType == 2">
      <div v-show="false" class="images" v-viewer="{movable: true}">
        <img :src="fileUrl" :key="fileUrl" />
      </div>
    </div>
    <div class="mod" v-if="viewerType == 3">
      <div @click="closeMod" class="mod__close">
        <span>x</span>
      </div>
      <Media
          :kind="'video'"
          :controls="true"
          :src="fileUrl"
      >
      </Media>
    </div>
    <div class="mod" v-if="viewerType == 4">
      <div @click="closeMod" class="mod__close">
        <span>x</span>
      </div>
      <Media
          :kind="'audio'"
          :controls="true"
          :src="fileUrl"
      >
      </Media>
    </div>
  </sweet-modal>
</template>

<script>
import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
import fileImg from "../fileImg";
import Media from "@dongido/vue-viaudio";
export default {
  name: "HeaderDocumentModal",
  components: {
    SweetModal,
    fileImg,
    Media
  },
  data(){
    return {
      params: {
        documentFiles: []
      },
      viewerType: 0,
      fileUrl: '',
      type: ''
    }
  },
  methods: {
    openModal(params) {
      this.params = params
      console.log('params', params)
      this.$refs.documentModal.open()
    },
    viewFile(url) {
      let type = url.split('.').pop().toUpperCase()
      if (type == 'GIF' || type == 'STEP' || type == 'STP' || type == 'IGES' || type == 'IGS' || type == 'BREP' || type == 'STL' || type == 'SAT' || type == 'X_T' || type == 'X_B' || type == 'SLDPRT' || type == 'DWG' || type == 'DXF' || type == 'DWF' || type == 'HPGL' || type == 'PLT' || type == 'CGM' || type == 'SVG' || type == 'EMF' || type == 'WMF' || type == 'JPG' || type == 'JPEG' || type == 'PNG' || type == 'BMP' || type == 'OGG' || type == 'MP4' || type == 'WMA' || type == 'MP3' || type == 'WAV' || type == 'OGG' || type == 'M4A' || type == 'PDF' || type === 'XLS' || type === 'DOCX' || type === 'DOC' || type === 'XLSX') {
        this.fileUrl = url
        this.type = this.fileUrl.split('.').pop().toUpperCase()
        console.log('---', this.fileUrl, this.type);

        if (this.type == 'GIF' || this.type == 'JPG' || this.type == 'JPEG' || this.type == 'PNG' || this.type == 'BMP') {
          this.viewerType = 2;
          setTimeout(() => {
            console.log('-----', this.$el);
            const viewer = this.$el.querySelector('.images').$viewer
            viewer.show()
          }, 300);
        } else if (this.type == 'OGG' || this.type == 'MP4') {
          this.viewerType = 3;
          setTimeout(() => {
            // this.$refs.video.open();
          }, 300);
        } else if (this.type == 'WMA' || this.type == 'MP3' || this.type == 'WAV' || this.type == 'OGG' || this.type == 'M4A') {
          this.viewerType = 4;
          setTimeout(() => {
            // this.$refs.video.open();
          }, 300);
        } else if (this.type == 'PDF') {
          this.viewerType = 1;
          this.fileUrl = process.env.VUE_APP_TF_PDF_VIEWER_BASE_URL + '/?file=' + this.fileUrl;
          setTimeout(() => {
            // this.$refs.nestedChild.open();
            window.open(this.fileUrl);
          }, 300);
        } else if (this.type == 'STEP' || this.type == 'STP' || this.type == 'IGES' || this.type == 'IGS' || this.type == 'BREP' || this.type == 'STL' || this.type == 'SAT' || this.type == 'X_T' || this.type == 'X_B' || this.type == 'SLDPRT' || this.type == 'DWG' || this.type == 'DXF' || this.type == 'DWF' || this.type == 'HPGL' || this.type == 'PLT' || this.type == 'CGM' || this.type == 'SVG' || this.type == 'EMF' || this.type == 'WMF') {
          // this.viewerType = 1;
          this.fileUrl = 'https://sharecad.org/cadframe/load?url=' + this.fileUrl;
          setTimeout(() => {
            // this.$refs.nestedChild.open();
            window.open(this.fileUrl);
          }, 300);
        }else if (this.type === 'XLS' || this.type === 'DOCX' || this.type === 'DOC' || this.type === 'XLSX'){
          const win = window.open(`https://view.officeapps.live.com/op/view.aspx?src=${this.fileUrl}`, '_blank');
          win.focus();
        }
      }
    },
    closeMod() {
      this.viewerType = 0;
    },
    close(){
      this.params = {
        documentFiles: []
      }
      this.viewerType = 0
      this.fileUrl = ''
      this.type = ''
    }
  }
}
</script>

<style scoped>

</style>
